<template>
  <v-col cols="12" class="text-right">
    <v-btn class="mr-1" @click="cancel">
      Cancel
    </v-btn>
    <v-btn
      v-if="canDestroy"
      @click="destroy"
      :disabled="!isValid || submitting"
      name="destroy"
      class="mr-1"
      color="warning"
    >
      Delete
    </v-btn>
    <v-btn
      v-if="canCreate"
      :disabled="!isValid || submitting"
      name="submit"
      type="submit"
      color="success"
    >
      Create
    </v-btn>
    <v-btn
      v-else-if="canEdit"
      :disabled="!isValid"
      :loading="submitting"
      name="submit"
      type="submit"
      color="success"
    >
      Update
    </v-btn>
  </v-col>
</template>

<script>
export default {
  props: {
    cancel: {
      type: Function,
      default: () => {},
    },
    submit: {
      type: Function,
      default: () => {},
    },
    destroy: {
      type: Function,
      default: () => {},
    },
    canDestroy: {
      type: Boolean,
      default: false,
    },
    canCreate: {
      type: Boolean,
      default: false,
    },
    canEdit: {
      type: Boolean,
      default: false,
    },
    submitting: {
      type: Boolean,
      default: false,
    },
    isValid: {
      type: Boolean,
      default: true,
    },
  },
};
</script>
